import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeSanitize from 'rehype-sanitize';
import { List, Text } from '@mantine/core';

interface Props {
    text: string;
    fz?: string;
    lh?: number;
}

export function MarkdownText({ text, fz = 'sm', lh = 1.55 }: Props): JSX.Element {
    return (
        <ReactMarkdown
            remarkPlugins={[remarkGfm]}
            rehypePlugins={[rehypeSanitize]}
            components={{
                p:      ({ children }) => <Text fz={fz} lh={lh} mb={6}>{children}</Text>,
                strong: ({ children }) => <Text span fw={600}>{children}</Text>,
                em:     ({ children }) => <Text span fs="italic">{children}</Text>,
                ul:     ({ children }) => <List fz={fz} withPadding mb={6}>{children}</List>,
                ol:     ({ children }) => <List type="ordered" fz={fz} withPadding mb={6}>{children}</List>,
                li:     ({ children }) => <List.Item>{children}</List.Item>,
                h1:     ({ children }) => <Text fw={700} fz="md" mt={8} mb={4}>{children}</Text>,
                h2:     ({ children }) => <Text fw={700} fz="sm" mt={8} mb={4}>{children}</Text>,
                h3:     ({ children }) => <Text fw={600} fz="sm" mt={6} mb={2} c="dimmed">{children}</Text>,
            }}
        >
            {text}
        </ReactMarkdown>
    );
}
